import classNames from 'classnames'
import { Box, Button, Icon, IconProps, Paragraph } from '@alto-avios/alto-ui'
import { RichText } from '~/components/contentful/ContentfulRichText'
import {
  NotificationMessageProps,
  NotificationMessageType,
} from '../../../../context/notification/notification.types'
import styles from './NotificationMessage.module.scss'

const iconProps: Record<NotificationMessageType, IconProps> = {
  ERROR: {
    iconName: 'triangle-exclamation',
    iconPrefix: 'far',
    color: 'criticalOnSubtle',
  },
  INFO: {
    iconName: 'circle-info',
    iconPrefix: 'far',
    color: 'informationPrimary',
  },
  SUCCESS: {
    iconName: 'circle-check',
    iconPrefix: 'far',
    color: 'successPrimary',
  },
  WARNING: {
    iconName: 'circle-info',
    iconPrefix: 'far',
    color: 'warningOnSubtle',
  },
}

const NotificationMessage = ({
  type,
  richText,
  text,
  buttonLabel,
  onButtonClick,
  onCloseClick,
}: NotificationMessageProps) => {
  return (
    <Box
      role="alert"
      as="alert"
      justifyContent="center"
      className={classNames(styles.wrapper, styles[type])}
    >
      <Box alignItems="center" justifyContent="center" gap="xs">
        <Icon {...iconProps[type]} iconSize="1.25x" />

        <Box className={styles.content}>
          {richText ? <RichText document={richText} /> : <Paragraph>{text}</Paragraph>}

          {buttonLabel && onButtonClick && (
            <Button emphasis="secondary" size="sm" onPress={onButtonClick}>
              {buttonLabel}
            </Button>
          )}
        </Box>

        <Button
          aria-label="Close"
          styleVariant="neutral"
          emphasis="quaternary"
          onPress={onCloseClick}
          iconEndProps={{ iconName: 'xmark', iconSize: '1.5x' }}
        />
      </Box>
    </Box>
  )
}

export default NotificationMessage
